import { Link } from "react-router-dom";
import type { Video } from "@/types";
import { categories } from "@/mocks/categories";
import { formatViews, relativeDate } from "@/utils/video";

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  const category = categories.find((c) => c.slug === video.category);

  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors">
      <Link to={`/detail/${video.id}`} className="block">
        <div className="relative w-full aspect-video overflow-hidden bg-background-200">
          <img
            src={video.cover}
            alt={`${video.title} 视频封面`}
            title={`${video.title} - 免费视频`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium text-background-50 bg-foreground-950/75 rounded">
            {video.duration}
          </span>
          <span className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-foreground-950/25">
            <span className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center text-background-50">
              <i className="ri-play-fill text-2xl leading-none" />
            </span>
          </span>
        </div>
        <div className="p-3 md:p-4">
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 leading-snug line-clamp-2 min-h-[2.6rem] group-hover:text-primary-600 transition-colors">
            {video.title}
          </h3>
          <p className="mt-1.5 text-xs md:text-sm text-foreground-600 line-clamp-2">
            {video.description}
          </p>
          <div className="mt-3 flex items-center justify-between gap-2">
            {category && (
              <span className="px-2 py-0.5 text-xs rounded-full bg-accent-100 text-accent-900 whitespace-nowrap">
                {category.name}
              </span>
            )}
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-eye-line" />
                {formatViews(video.views)}
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap">
                <i className="ri-time-line" />
                {relativeDate(video.uploadDate)}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}